/*
  In-page anchor links (sections/custom-anchor.liquid). Dawn reveals the
  sticky header whenever the page scrolls up, which would cover the target
  of an upward jump. Ask the header to stay hidden for that scroll.
*/
(() => {
  if (window.__customAnchorLinks) return;
  window.__customAnchorLinks = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || event.defaultPrevented) return;

    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;

    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target || target.getBoundingClientRect().top >= 0) return;

    document.querySelector('sticky-header')?.dispatchEvent(new Event('preventHeaderReveal'));
  });
})();
